import { useMutation } from 'react-query';
import ExportAPI from 'services/API/ExportAPI';
import { FilterViewEnum } from 'types/FilterProjects';

type Props = {
  selectedFilterCategories?: FilterViewEnum[];
  onMutate?: () => void;
  onSuccess?: (data: string | null) => void;
};

export const useExportCollection = ({
  selectedFilterCategories,
  onMutate,
  onSuccess,
}: Props) => {
  const exportToCSV = useMutation({
    onMutate,
    onSuccess,
    mutationFn: async (collectionId: number) => {
      const response = await ExportAPI.postCollectionCsvExport({
        collectionId,
        selectedFilterCategories,
      });

      const url = response?.data?.url;
      if (url) {
        window.open(url, '_blank');
      }

      return url || null;
    },
  });

  return { exportToCSV };
};
